import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import Choices from "@/pages/Choices";

export const Route = createFileRoute("/choices")({
  component: Choices,
  head: () =>
    pageHead({
      title: "Your Privacy Choices | jaik",
      description: "Opt out of SMS, marketing emails, targeted advertising, or request deletion of your personal information.",
      path: "/choices",
    }),
});
